import { InjectionToken, Injector } from '@angular/core';

export const FLOATING_DIALOG_DATA = new InjectionToken<any>('FLOATING_DIALOG_DATA');

export interface FloatingDialogConfig<D = any> {
  data?: D;
  id?: string;
  injector?: Injector;
  modal?: boolean;
  closable?: boolean;
  closeOnEscape?: boolean;
  maximizable?: boolean;
  resizable?: boolean;
  closeOnOutsideClick?: boolean;
  fitContent?: boolean;
  closeOnNavigation?: boolean;
  width?: string;
  height?: string;
  minWidth?: number | string;
  minHeight?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
}

type FloatingDialogSizeKeys = 'width' | 'height' | 'minWidth' | 'minHeight' | 'maxWidth' | 'maxHeight';

export type ResolvedFloatingDialogConfig<D = any> =
  Required<Omit<FloatingDialogConfig<D>, 'data' | 'id' | 'injector' | FloatingDialogSizeKeys>>
  & Pick<FloatingDialogConfig<D>, 'data' | 'id' | 'injector' | FloatingDialogSizeKeys>;

export const FLOATING_DIALOG_DEFAULT_CONFIG: ResolvedFloatingDialogConfig = {
  modal: true,
  closable: true,
  closeOnEscape: true,
  maximizable: true,
  resizable: true,
  closeOnOutsideClick: false,
  fitContent: false,
  closeOnNavigation: true
};
